document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-option-select]');
  if (!select) return;

  const form = select.closest('[data-product-form]');
  const page = select.closest('[data-product-page]');
  if (!form || !page) return;

  const variantInput = form.querySelector('[data-variant-id]');
  const variantData = form.querySelector('[data-variants-json]');
  if (!variantInput || !variantData) return;

  const variants = JSON.parse(variantData.textContent);
  const selectedOptions = Array.from(form.querySelectorAll('[data-option-select]')).map((field) => field.value);
  const match = variants.find((variant) => selectedOptions.every((value, index) => variant.options[index] === value));
  if (!match) {
    variantInput.value = '';
    const button = form.querySelector('[data-add-to-cart]');
    const status = form.querySelector('[data-variant-status]');
    if (button) {
      button.disabled = true;
      button.textContent = 'Unavailable';
    }
    if (status) status.textContent = 'This option combination is unavailable.';
    return;
  }

  variantInput.value = match.id;
  const gallery = page.querySelector('[data-product-gallery]');
  if (gallery) {
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const imageId = match.featured_image && String(match.featured_image.id);
    const thumbnail = thumbnails.find((item) => item.dataset.imageId === imageId) || thumbnails[0];
    if (thumbnail) thumbnail.click();
  }
  const variantUrl = new URL(window.location.href);
  variantUrl.searchParams.set('variant', match.id);
  window.history.replaceState(window.history.state, '', variantUrl);
  const addButton = form.querySelector('[data-add-to-cart]');
  const quantityInput = form.querySelector('[data-product-quantity]');
  const status = form.querySelector('[data-variant-status]');
  const isLowStock = Boolean(match.available && match.inventory_management && match.inventory_quantity > 0 && match.inventory_quantity < 5);

  if (addButton) {
    addButton.disabled = !match.available;
    addButton.textContent = match.available ? 'Add to cart' : 'Sold out';
  }

  if (quantityInput) {
    if (match.inventory_management && match.inventory_policy === 'deny') {
      quantityInput.max = Math.max(0, match.inventory_quantity);
      if (Number(quantityInput.value) > match.inventory_quantity) quantityInput.value = Math.max(1, match.inventory_quantity);
    } else {
      quantityInput.removeAttribute('max');
    }
  }

  if (status) {
    status.textContent = !match.available ? 'Sold Out' : isLowStock ? 'Less Than 5 Left' : '';
    status.classList.toggle('is-sold-out', !match.available);
    status.classList.toggle('is-low', isLowStock);
  }
  const price = page.querySelector('[data-product-price]');
  if (price) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      price.textContent = window.Shopify.formatMoney(match.price);
    } else {
      price.textContent = (match.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.product-form');
  if (!form) return;

  const addButton = form.querySelector('[data-add-to-cart]');
  if (addButton && addButton.disabled) {
    event.preventDefault();
  }
}, true);


(function () {
  const cleanText = (value) => (value || '').replace(/s+/g, ' ').trim().slice(0, 120);

  const track = (eventName, params = {}) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, Object.assign({
      event_category: 'storefront',
      page_path: window.location.pathname
    }, params));
  };

  const normalizedUrl = (href) => {
    try {
      const url = new URL(href, window.location.href);
      return url.hostname === window.location.hostname ? url.pathname + url.search : url.href;
    } catch (error) {
      return href;
    }
  };

  const clickArea = (element) => {
    if (element.closest('.primary-nav')) return 'primary_nav';
    if (element.closest('.product-card, [data-product-card]')) return 'product_card';
    if (element.closest('.header-actions')) return 'header';
    if (element.closest('footer, .site-footer')) return 'footer';
    if (element.closest('[class*="collection"], [id*="collection"]')) return 'collection_area';
    return 'content';
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const url = normalizedUrl(href);
    const area = clickArea(link);
    const text = cleanText(link.innerText || link.getAttribute('aria-label') || url);
    const isProduct = url.includes('/products/');
    const isCollection = url.includes('/collections/');

    if (area !== 'content' || isProduct || isCollection) {
      track('site_click', {
        click_area: area,
        link_text: text,
        link_url: url
      });
    }

    if (isProduct) {
      track('product_link_click', {
        click_area: area,
        link_text: text,
        link_url: url
      });
      track('select_item', {
        item_list_name: area,
        items: [{ item_name: text, item_id: url }]
      });
    }

    if (isCollection) {
      track('collection_link_click', {
        collection_name: text,
        click_area: area,
        link_url: url
      });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    const searchInput = form.querySelector('input[type="search"], input[name="q"]');
    if (action.includes('/search') || form.getAttribute('role') === 'search') {
      track('site_search_submit', {
        search_term: cleanText(searchInput ? searchInput.value : '')
      });
    }

    if (action.includes('/cart/add')) {
      const itemName = cleanText(document.querySelector('h1, .product-title, [data-product-title]')?.textContent || document.title);
      const variantId = form.querySelector('[name="id"], [data-variant-id]')?.value || '';
      track('add_to_cart', {
        currency: 'USD',
        item_name: itemName,
        item_id: variantId,
        items: [{ item_name: itemName, item_id: variantId }]
      });
    }
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-option-select]');
    if (!select) return;

    track('product_option_change', {
      option_name: cleanText(select.getAttribute('name') || select.getAttribute('aria-label') || 'Product option'),
      option_value: cleanText(select.value)
    });
  });
})();

(function () {
  const selectGalleryThumbnail = (thumbnail) => {
    const gallery = thumbnail && thumbnail.closest('[data-product-gallery]');
    const mainImage = gallery && gallery.querySelector('.product-main-image');
    const lightboxImage = gallery && gallery.querySelector('[data-gallery-lightbox-image]');
    if (!gallery || !mainImage || !thumbnail) return;

    mainImage.removeAttribute('srcset');
    mainImage.src = thumbnail.dataset.imageUrl;
    mainImage.alt = thumbnail.dataset.imageAlt || '';
    if (lightboxImage) {
      lightboxImage.src = thumbnail.dataset.imageZoomUrl || thumbnail.dataset.imageUrl;
      lightboxImage.alt = thumbnail.dataset.imageAlt || '';
    }
    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((item) => {
      item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false');
    });
  };

  const closeGallery = (lightbox) => {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.classList.remove('gallery-open');
    if (lightbox._galleryOpener) lightbox._galleryOpener.focus();
  };

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-gallery-thumbnail]');
    if (thumbnail) {
      selectGalleryThumbnail(thumbnail);
      return;
    }

    const galleryStep = event.target.closest('[data-gallery-step]');
    if (galleryStep) {
      const gallery = galleryStep.closest('[data-product-gallery]');
      const thumbnails = Array.from(gallery ? gallery.querySelectorAll('[data-gallery-thumbnail]') : []);
      if (!thumbnails.length) return;

      const currentIndex = Math.max(0, thumbnails.findIndex((item) => item.getAttribute('aria-current') === 'true'));
      const direction = Number(galleryStep.dataset.galleryStep) || 1;
      const nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
      selectGalleryThumbnail(thumbnails[nextIndex]);
      return;
    }

    const openButton = event.target.closest('[data-gallery-open]');
    if (openButton) {
      const gallery = openButton.closest('[data-product-gallery]');
      const lightbox = gallery && gallery.querySelector('[data-gallery-lightbox]');
      const mainImage = gallery && gallery.querySelector('.product-main-image');
      const lightboxImage = gallery && gallery.querySelector('[data-gallery-lightbox-image]');
      if (!lightbox || !mainImage || !lightboxImage) return;

      lightboxImage.src = mainImage.currentSrc || mainImage.src;
      lightboxImage.alt = mainImage.alt || '';
      lightbox._galleryOpener = openButton;
      lightbox.hidden = false;
      document.body.classList.add('gallery-open');
      const closeButton = lightbox.querySelector('.product-lightbox-close');
      if (closeButton) closeButton.focus();
      return;
    }

    const closeButton = event.target.closest('[data-gallery-close]');
    if (closeButton) closeGallery(closeButton.closest('[data-gallery-lightbox]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeGallery(document.querySelector('[data-gallery-lightbox]:not([hidden])'));
  });
})();
